import React, { useEffect, useCallback, useState } from "react";
import $ from "jquery";
import { withTranslation } from "react-i18next";
import { Button } from "primereact/button";
import TamaraPayIcon from "../Icons/tamara.svg";
import TamaraPayIconAr from "../Icons/tamara-ar.svg";
import { useSelector } from "react-redux";
import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
} from "../../../helpers/utils";
import { getPaymentOptionsTamara } from "../../../services/common";
import { RadioButton } from "primereact/radiobutton";

function SplitPay(props) {
  const tamaraMinLimitCommon = 100;
  const tamaraMaxLimitCommon = 10000;
  const tamaraWidgetCutoffLimit = 6000;

  const { businessLine } = useSelector((state) => state.travel);

  const paymentOptions = {
    "available_payment_labels": [
        {
            "payment_type": "PAY_BY_INSTALMENTS",
            "instalment": 3,
            "description_en": "Split in 3 payments without interest or hidden fees",
            "description_ar": "قسم فاتورتك على 3 دفعات بدون فوائد ورسوم خفية"
        },
        {
            "payment_type": "PAY_BY_INSTALMENTS",
            "instalment": 4,
            "description_en": "Split in 4 payments without interest or hidden fees",
            "description_ar": "قسم فاتورتك على 4 دفعات بدون فوائد ورسوم خفية"
        },
        {
            "payment_type": "PAY_BY_INSTALMENTS",
            "instalment": 6,
            "description_en": "Split in 6 payments without interest or hidden fees",
            "description_ar": "قسم فاتورتك على 6 دفعات بدون فوائد ورسوم خفية"
        }
    ],
    "has_available_payment_options": true,
    "single_checkout_enabled": false
}

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;


  console.log('props.optionsTamara');

  console.log(props.optionsTamara);




  return (
    <div className="grid p-fluid">
      <div
        className="d-flex flex-column justify-content-center align-items-center w-100"
        style={{ minHeight: "300px" }}
      >
        {props.optionsTamara?.map((item, index) => (
          <div className="field-radiobutton d-flex justify-content-center w-100 mb-4 gap-4 align-items-baseline" key={index}>
            <RadioButton
              inputId="tamara-2split"
              name="tamara-split"
              value={item.instalment}
              onChange={(e) => props.setSplitPayment(e.value)}
              checked={props.splitPayment === item.instalment}
            />
            <label htmlFor="tamara-2split">
              <div className="tamara-name">
                <span className="tamara-line-height">
                  {" "}
                  {props.i18n.language === "ar"
                    ? item.description_ar
                    : item.description_en}{" "}
                </span>
                <strong className="fm-tawuniya tamara-line-height">
                  {" "}
                  {(+props.totalAmount / item.instalment).toFixed(2)}
                  {" "}{props.i18n.t("SAR")}
                </strong>
              </div>
          
            </label>
          </div>
        ))}

        <h4 className="my-3">{props.i18n.t("common.tamara_question")}</h4>
        <div className="btn-group">
          <Button
            loading={props.loading}
            className="btn primary mb-3"
            onClick={() => {
              props.tamaraCreateSession();
            }}
            disabled={!props.ackAgree || (!props.splitPayment && paymentOptions)}
            style={{ background: businessColor }}
          >
            {props.i18n.t("CONFIRM")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(SplitPay);
